<template>
  <div class="container-full">
    <div class="banner">
      <img src="https://img.sunlove-iread.com/uploads/readingtips/1920.png" class="b1" />
      <img src="https://img.sunlove-iread.com/uploads/readingtips/1200.png" class="b2" />
      <img src="https://img.sunlove-iread.com/uploads/readingtips/750.png" class="b3" />
      <img class="b4" src="../../assets/img/arrow-up-circle.png" />
    </div>

    <Modal v-model="modal2" width="450">
      <div style="text-align: center">
        <p>
          <Icon
            style="font-size: 18px; color: #ed4014; margin-right: 10px"
            type="ios-information-circle"
          ></Icon
          >您的内容已提交。感谢您的关注与支持！
        </p>
      </div>
      <div slot="footer">
        <Button
          type="info"
          size="large"
          long:loading="modal_loading"
          @click="modal2 = false"
          >返回</Button
        >
      </div>
    </Modal>

    <div class="video-list container">
      <div class="p1">
        <div class="pbox">
          <div class="msg">
            <h3 class="text-center">寻找「阳光领读人」</h3>
            <p>
              2022年，由中国社会福利基金会、东风日产、南方周末联合发起的“阳光关爱·i读计划”为爱前行，先后为广东清远、甘肃天水、四川凉山、山西临汾四地的乡村小学捐建“阳光关爱阅读室”，并通过丰富的线上线下课程及阅读活动，致力于让更多乡村孩子爱上阅读。<br />
              新年到来之际，我们诚邀你成为「阳光领读人」。无论你从事何种职业，只要热爱阅读，就欢迎分享你的阅读心得。我们将汇聚优秀内容，整合成为“阳光关爱·i读计划”新年阅读攻略，并向全网开放，指引更多孩子走上阅读之路！
            </p>
          </div>
        </div>
        <!-- <div class="map" id="baidumap">
          <img src="../../assets/img/volunteer/map.png" class="m1" />
          <img src="../../assets/img/volunteer/map2.png" class="m2" />
        </div> -->
      </div>

      <div class="p2">
        <div class="p2top">
          <!-- <ul class="a">
            <li class="one">活动说明：</li>
            <li>{{ volunteerData.s1 }}</li>
          </ul>
          <ul class="a">
            <li class="one">报名条件：</li>
            <li>{{ volunteerData.s2 }}</li>
          </ul>
          <ul class="a">
            <li class="one">支教学校：</li>
            <li>{{ volunteerData.s3 }}</li>
          </ul> -->
          <ul class="a">
            <li class=""><h3><span class="red">*</span>为必填项</h3></li>
            <li>&nbsp;</li>
          </ul>
          <div class="formbox">
            <div class="formtitle">
              <h3>1. 新的一年，您推荐儿童阅读哪些好书？</h3>
              <span class="red">*</span>
            </div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <Input
                  class="fontbig"
                  v-model="postData.aq1"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  placeholder="请在此处填入书名，数量不限。欢迎附上简短的荐书理由"
                />
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">
              <h3>2. 您建议儿童培养什么样的阅读方法？</h3>
            </div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <Input
                  class="fontbig"
                  v-model="postData.aq2"
                  placeholder="请在此处填写"
                />
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">
              <h3>3. 对于乡村孩子，您最想说什么？</h3>
              <span class="red">*</span>
            </div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <Input
                  class="fontbig"
                  v-model="postData.aq3"
                  placeholder="请在此处填写"
                />
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">
              <h3>4. 您认为阅读最大的意义是什么？</h3>
            </div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <Input
                  class="fontbig"
                  v-model="postData.aq4"
                  placeholder="请在此处填写"
                />
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">
              <h3>5. 你如何看待乡村教育的现状？对未来有何建议？</h3>
            </div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 24 }">
                <Input
                  class="fontbig"
                  v-model="postData.aq5"
                  placeholder="请在此处填写"
                />
              </Col>
            </Row>
          </div>
          <div class="formbox">
            <div class="formtitle">
              <h3>您的个人资料</h3>
              <span class="red">*</span>
            </div>
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 24 }" :lg="{ span: 10 }">
                <Input
                  class="fontbig"
                  v-model="postData.name"
                  placeholder="姓名/昵称 （内容一经选用，将展示您的姓名或昵称）"
                />
              </Col>
            </Row>
            <!-- <div class="formtitle mt10">
              <h3>联系方式</h3>
              <span class="red">*</span>
            </div> -->
            <Row>
              <Col :xs="24" :sm="24" :md="{ span: 10 }" :lg="{ span: 10, }">
                
                <Input
                  class="fontbig"
                  v-model="postData.mobile"
                  placeholder="联系手机或邮箱"></Input>
              </Col>
                <Col :xs="24" :sm="24" :md="{ span: 10 }" :lg="{ span: 10,offset:2 }">
                  <Input
                  class="fontbig"
                  v-model="postData.address"
                  placeholder="您的职业及所在单位/学校"
                ></Input>
              </Col>
                <Col :xs="24" :sm="24" :md="{ span: 10}" :lg="{ span: 10}">
                <Input
                  class="fontbig"
                  v-model="postData.city"
                  placeholder="您所在的省份及城市"
                >
                  <span slot="append">省-市</span>
                </Input>
              </Col>
            </Row>
           
            <Row>
              
            </Row>
          </div>
         

          <div class="formbox submitbox">
            <button v-if="volunteerData && !volunteerData.isStart">
              志愿者报名已截止
            </button>
            <button v-if="volunteerData.isStart" @click="submit()">提交</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import header from "../public/header.vue";
// import footer from "../public/footer.vue";
// import routerLink from "../public/routerlink.vue";
import { RegionColumns } from 'v-region'
export default {
  // name: "app",
  components: {
    RegionColumns
    // 'app-header': header,
    // 'app-footer': footer,
    // 'routerLink': routerLink,
    // routerLink,
  },
  data() {
    return {
      modal2: false,
      volunteerData: {},
      resiteData: {},
      postData: {
        aq1: "",
        aq2: "",
        aq3: "",
        aq4: "",
        aq5: "",
        name: "",
        mobile: "",
        address: "",
        province:"",
        city: "",
      },
      routername: "",
      routerData: [{ title: "我要参与", link: "volunteer" }]
    };
  },
  created() {
    this.resiteData = JSON.parse(JSON.stringify(this.postData));
    this.routername = this.$route.name;
    this.$Message.config({
      top: 120,
      duration: 3
    });
    this.$http.get("/Index/Config/data&key=volunteer").then(res => {
      this.volunteerData = res.value;
    });
    //this.modal2=true
    //  this.$http.get("/Index/Config/data&key=volunteer").then(res => {
    //       this.volunteerData= res.value;
    //     });
  },
  methods: {
    regionChange (data) {
      console.log(data)
    },
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      this.postData.kcfile.splice(this.postData.kcfile.indexOf(file.url), 1);
    },
    handleSuccess(res, file) {
      file.url = res.body.url;
      this.postData.kcfile.push(res.body.url);
    },
    handleFormatError() {
      this.$Modal.warning({
        title: "格式不正确请上传zip格式"
      });
    },
    handleMaxSize() {
      this.$Modal.warning({
        title: "上传文件超过最大限制5MB"
      });
    },
    handleBeforeUpload() {
      const check = this.postData.kcfile.length < 1;
      if (!check) {
        this.$Modal.warning({
          title: "只能上传一个附件"
        });
      }
      return check;
    },
    pushKs() {
      this.postData.kc.push({ curriculum: "", course: "", kcradio: "" });
    },
    submit() {
      
      if (!this.postData.aq1) {
        this.$Message.error("请输入问题1");
        return;
      }
      if (!this.postData.aq3) {
        this.$Message.error("请输入问题3");
        return;
      }
      if (!this.postData.name) {
        this.$Message.error("请输入姓名或者昵称");
        return;
      }
      if (!this.postData.mobile) {
        this.$Message.error("请输入邮箱或电话");
        return;
      }
      
      let reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (!(reg.test(this.postData.mobile) || /^1[3456789]\d{9}$/.test(this.postData.mobile))) {
        this.$Message.error("请填写正确的邮箱或电话!");
        return;
      }
      // if (!this.postData.province) {
      //   this.$Message.error("请填写省");
      //   return;
      // }
      if (!this.postData.address) {
        this.$Message.error("请填写您的职业及所在单位/学校");
        return;
      }
      if (!this.postData.city) {
        this.$Message.error("请填写您所在的省份及城市");
        return;
      }
      // if (!this.postData.city) {
      //   this.$Message.error("请填写市");
      //   return;
      // }
      // if (!this.postData.car) {
      //   this.$Message.error("请选择是否为车主");
      //   return;
      // }
      // if (!this.postData.course) {
      //   this.$Message.error("课程内容与教学设计");
      //   return;
      // }

      // if (!this.postData.kc) {

      //   this.$Message.error("课程名称或主题");
      //   return;
      // }
      // if (!this.postData.agegroup) {
      //   this.$Message.error("请选择适应年级");
      //   return;
      // }

      // return false;
      this.$http.post("/Index/Index/readingtips", this.postData).then(res => {
        if (res) {
          this.postData = JSON.parse(JSON.stringify(this.resiteData));
          this.modal2 = true;
          this.$refs.upload.fileList = [];
        }

        // this.$Message.success("提交成功");
        // this.$Modal.success({
        //             title: 'Title',
        //             content: '<p>Content of dialog</p><p>Content of dialog</p>',
        //             okText: 'OK',
        //             cancelText: 'Cancel'
        //         });
      });
      // console.log(this.postData);
    }
  },
  mounted() {}
};
</script>
<style lang="less" >
.ivu-modal-confirm-head,
.ivu-modal-confirm-footer {
  text-align: center !important;
}
.ivu-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
@media (max-width: 576px) {
  .ivu-modal {
    width: 80% !important;
    margin: 10px;
  }
}
</style>
<style lang="less" scoped>
.b1,
.b2,
.b3,
.b4,
.m1,
.m2 {
  display: none;
}
.banner {
  position: relative;
}
.banner img {
  width: 100%;
}

.container-full {
  background: #f7f7f7;
}
.fontbig {
  //   font-size: 24px;
  margin-top: 20px;
}
.msg {
  padding: 36px;
  border-top: 9px solid #eb565a;
  background-color: #fff;
  //   width: 850px;
  //   height: 603px;
  width: 100%;
  margin-right: 50px;
  float: left;
  h3 {
    font-size: 28px;
    font-weight: 500;
  }
  p {
    white-space: pre-line;
    font-size: 22px;
    line-height: 30px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    margin-top: 40px;
    text-align: justify;
  }
}
.p1 {
  padding: 70px 0 90px;
  clear: both;
  overflow: hidden;
}
.map {
  height: 600px;
  width: 680px;
  float: left;
}
.p2 {
  padding: 80px 250px;
  background-color: #fff;
}
.submitbox {
  text-align: center;
  button {
    // width: 150px;
    padding: 0 20px;
    height: 58px;
    line-height: 58px;
    border: 1px solid #eb565a;
    color: #eb565a;
    background: #fff;
  }
}
.p2top {
  ul.a {
    display: flex;
    justify-content: space-around;
    padding: 0;
    li {
      white-space: pre-line;
      list-style: none;
      width: 100%;
      font-size: 20px;
      line-height: 53px;
      color: #222;
    }
    li.one {
      flex: 1 0 150px;
      width: 150px;
      font-size: 24px;
      font-weight: 500;
      text-align: right;
    }
    li.two {
      flex: 1 0 150px;
      width: 150px;
      font-size: 18px;
      text-align: right;
    }
  }
}
.formtitle {
  font-size: 28px;
  font-weight: 500;
  line-height: 53px;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: flex-start;
}
.red {
  color: red;
}
.stitle {
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
}
.form-margin-top {
  margin-top: 20px;
}
.formbox {
  padding: 30px 0;
  border-top: 1px dashed #dcdcdc;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
  .row {
    .col-md-6 {
      margin-top: 22px;
    }
    /*  */

    /*  */
  }
}
/deep/ .ivu-checkbox-wrapper {
  font-size: 16px;
}
.pbox {
  overflow: hidden;
  float: left;
}
@media (min-width: 1201px) {
  .b1 {
    display: block;
  }
}

@media (min-width: 1640px) {
  .m1 {
    display: block;
  }
}
@media (max-width: 1640px) and (min-width: 1200px) {
  .m2 {
    display: block;
  }
  .map {
    height: 676px;
    width: 482px;
  }
  .msg {
    //   width: 850px;
    //   height: 603px;
    width: 100%;
    box-sizing: border-box;
  }
  .p2 {
    padding: 60px 100px;
    background-color: #fff;
  }
}

@media (max-width: 1200px) and (min-width: 768px) {
  .b2 {
    display: block;
  }
  .msg {
    float: none;
    width: 100%;
    height: auto;
  }

  .m1 {
    display: block;
  }
  .pbox {
    padding: 0 30px;
  }
  .map {
    margin-top: 50px;
    width: 100%;
    img {
      width: 100%;
      height: 500px;
    }
  }
  .video-list {
    width: 100% !important;
    padding: 0;
  }
  .p2 {
    padding: 60px 20px;
    background-color: #fff;
  }
}

@media (max-width: 900px) {
  .p2top {
    ul {
      display: flex;
      li {
        list-style: none;
        font-size: 16px;
        line-height: 53px;
        color: #222;
      }
      li.one {
        flex: 1 0 150px;
        width: 150px;
        font-size: 20px;
        font-weight: 500;
        text-align: right;
      }
    }
  }
}
@media (max-width: 768px) {
  .p1 {
    padding: 30px 0 40px;
    clear: both;
    overflow: hidden;
  }
  .b3,
  .m1,
  .b4 {
    display: block;
  }
  .msg {
    float: none;
    width: 100%;
    height: auto;
    padding: 16px;
    h3 {
      font-size: 18px;
      font-weight: 500;
    }
    p {
      font-size: 12px;
      line-height: 18px;
      margin-top: 20px;
    }
  }
  .formtitle {
    font-size: 18px;
    line-height: 24px;
  }
  .pbox {
    padding: 0 30px;
  }
  .map {
    margin-top: 50px;
    height: 300px;
    width: 100%;
    img {
      width: 100%;
      height: 500px;
    }
  }
  .video-list {
    width: 100% !important;
    padding: 0;
  }
  .p2 {
    padding: 60px 20px;
    background-color: #fff;
  }
  .p2top {
    ul {
      display: flex;
      justify-content: space-around;
      flex-flow: wrap;
      clear: both;
      li {
        list-style: none;
        width: 100%;
        font-size: 12px !important;
        line-height: 24px !important;
        color: #222;
      }
      li.one {
        flex: 1 0 80px !important;
        font-size: 18px !important;
        margin: 10px 0;
        font-weight: bold;
        text-align: left !important;
      }
      li.two {
        flex: 1 0 100px;
        font-size: 14px;
        text-align: left !important;
        text-align: justify;
      }
    }
  }
  .submitbox {
    text-align: center;
    button {
      // width: 80px;
      padding: 0px 15px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      border: 1px solid #eb565a;
      color: #eb565a;
      background: #fff;
    }
  }
}
.dec {
  font-size: 12px;
}
.btline {
  border-bottom: 1px dashed #dcdcdc;
  padding: 10px 0;
}
/deep/ .ivu-upload-list {
  font-size: 12px;
}
.mt10 {
  margin-top: 10px;
}
.b4 {
  position: absolute;
  width: 40px !important;
  left: 50%;
  bottom: 100px;
  margin-left: -20px;
  animation: bounce-inSS 2s infinite;
}
@keyframes bounce-inSS {
  0% {
    transform: translateY(0);
    // opacity: 0.8;
  }
  80% {
    transform: translateY(-20px);
    opacity: 1;
  }
  100% {
    transform: translateY(-20px);
    // opacity: 1;
  }
}
</style>